<template>
  <div class="card totals-card mb-2">
    <div class="card-header">
      <div class="card-title-group">
        <span class="card-title-icon">
          <i class="bi bi-cash-coin"></i>
        </span>
        <h5 class="mb-0">Totales de la venta</h5>
      </div>
    </div>
    <div class="card-body">
      <div class="totals-card__grid">
        <div class="totals-card__col">
          <div class="total-row">
            <span class="label">Subtotal</span>
            <span v-if="disciva" class="value">{{formatoDinamicoMoneda(totals.gross)}}</span>
            <span v-else class="value">{{formatoDinamicoMoneda(totals.prices)}}</span>
          </div>

          <div class="total-row totals-card__discount-row">
            <span class="label">Descuento</span>
            <span class="totals-card__discount-right">
              <template v-if="discount_each_line == false">
                <input
                  v-model.number="discountAmount"
                  type="number"
                  min="0"
                  class="form-control form-control-sm totals-card__discount-input"
                  placeholder="0">
                <div class="btn-group btn-group-sm" role="group">
                  <button
                    type="button"
                    class="btn"
                    :class="discountType === 'percentage' ? 'btn-primary' : 'btn-outline-secondary'"
                    @click="discountType = 'percentage'"
                  >%</button>
                  <button
                    type="button"
                    class="btn"
                    :class="discountType === 'amount' ? 'btn-primary' : 'btn-outline-secondary'"
                    @click="discountType = 'amount'"
                  >$</button>
                </div>
              </template>
              <span class="value text-success">
                <template v-if="totals.tdiscount > 0">− </template>{{formatoDinamicoMoneda(totals.tdiscount)}}
              </span>
            </span>
          </div>

          <div v-if="disciva" class="totals-card__iva-summary">
            <span class="totals-card__iva-summary-group">
              <template v-for="(part, index) in ivaSummaryParts">
                <span v-if="index > 0" :key="'sep-' + index" class="totals-card__iva-summary-sep"></span>
                <span :key="'part-' + index" class="totals-card__iva-summary-text">{{ part }}</span>
              </template>
            </span>
            <span v-if="letter" class="totals-card__type-tag">TIPO {{ letter }}</span>
          </div>
        </div>
      </div>

      <div class="totals-divider"></div>

      <div class="total-row total-final">
        <span class="label">Total</span>
        <span class="value">{{formatoDinamicoMoneda(totals.total)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import formatMoneyMixin from "../../../../mixins/formatMoneyMixin";

  export default {

    props: ['products', 'disciva', 'clientDiscount','discount_each_line', 'discount_each_line_type', 'discount', 'grossTotal', 'priceTotal', 'letter', 'initialDiscount', 'initialDiscountType'],
    mixins: [formatMoneyMixin],
    data: function() {
      return {
        inputdiscount : null,
        totals : {
          gross : 0,
          taxes: {},
          ftaxes: {},
          prices: 0,
          pdiscount : 0,
          tdiscount : 0,
          net : 0,
          total : 0
        }
      }
    },
    watch: {
      products: {
        handler: function() {
          this.calculateGross();
        },
        deep: true,
      },
      disciva: {
        handler: function() {
          this.calculateGross();
        },
      },
      discount:{
        handler: function() {
          var app=this;
          if(app.discount_each_line==1){
            if(app.discount_each_line_type !== undefined && app.discount_each_line_type == 'amount')
              app.inputdiscount='$' + app.discount;
            // else
            //   if(app.disciva !== undefined && app.disciva == true)
            //     app.inputdiscount='%' + (app.discount * 100) / app.grossTotal;
            //   else
            //     app.inputdiscount='%' + (app.discount * 100) / app.priceTotal;

            app.calcdiscount(app.inputdiscount);
            app.calculate();
          }
        },
      },
      inputdiscount: function() {
        var app = this;
        app.calcdiscount(app.inputdiscount);
        app.calculate();
      },
      clientDiscount: {
        handler: function(){
          var app = this;
          app.inputdiscount = app.clientDiscount + '%';
          app.calcdiscount(app.inputdiscount);
          app.calculate();
        },
      },
    },
    mounted: function() {
      // Semilla de un descuento global pre-cargado (combo con descuento
      // propio) cuando no hay descuento por linea. Corre una sola vez: de
      // ahi en mas el usuario lo edita como cualquier otro "10% o $10" del
      // input y pierde relacion con el prop.
      if (!this.discount_each_line && this.initialDiscount) {
        this.inputdiscount = this.initialDiscountType === 'amount'
          ? '$' + this.initialDiscount
          : this.initialDiscount + '%';
      }
    },
    computed: {
      ivaSummaryParts: function () {
        var app = this;
        var parts = ['Neto ' + app.formatoDinamicoMoneda(app.totals.net)];
        Object.keys(app.totals.ftaxes).forEach(function (key) {
          parts.push('IVA ' + key + '% ' + app.formatoDinamicoMoneda(app.totals.ftaxes[key]));
        });
        return parts;
      },
      // Toggle %/$ en vez del texto libre "10% o $10": estos dos computed
      // son la unica interfaz nueva, pero siguen escribiendo/leyendo
      // inputdiscount, que sigue siendo la fuente de verdad real (la que
      // mira calcdiscount() y clampea internamente). Cero cambios en la
      // logica de calculo existente.
      discountType: {
        get: function () {
          return (this.inputdiscount && this.inputdiscount.indexOf('$') > -1) ? 'amount' : 'percentage';
        },
        set: function (type) {
          var amount = this.discountAmount || 0;
          this.inputdiscount = type === 'amount' ? ('$' + amount) : (amount + '%');
        },
      },
      discountAmount: {
        get: function () {
          if (!this.inputdiscount) return null;
          var n = parseFloat(this.inputdiscount.replace('%', '').replace('$', ''));
          return isNaN(n) ? null : n;
        },
        set: function (value) {
          this.inputdiscount = this.discountType === 'amount' ? ('$' + value) : (value + '%');
        },
      },
    },
    methods: {
      roundtofix: function(value, decimals) {
        return (Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)).toFixed(decimals);
      },
      round: function(value, decimals) {
        return (Number(Math.round(value + 'e' + decimals) + 'e-' + decimals));
      },
      calculateGross: function() {
        var app=this;

        let gross=0;
        let prices=0;
        let taxes={};

        for (let i = 0; i < app.products.length; i++) {
          taxes[app.products[i].taxtype] = 0;
        }

        for (let i = 0; i < app.products.length; i++) {
          gross+= app.products[i].gross * app.products[i].quantity;
          prices+= app.products[i].price * app.products[i].quantity;
          taxes[app.products[i].taxtype] += app.products[i].tax * app.products[i].quantity;
        }
        app.totals.gross = gross;
        app.totals.prices = prices;
        app.totals.taxes = taxes;

        if(app.discount_each_line==1){
          app.inputdiscount='$' + app.discount;
        }

        app.calcdiscount(app.inputdiscount);
        app.calculate();
      },
      calcdiscount: function(inputd) {
        if (inputd!=null) {
          this.totals.pdiscount=0;
          this.totals.tdiscount=0;

          var base = 0;
          if (this.disciva) {
            base = this.totals.gross;
          } else {
            base = this.totals.prices;
          }
          if (inputd.indexOf('%')>-1) {
            var filterd = parseFloat(this.inputdiscount.replace('%',''));
            if (filterd>100) {
              this.inputdiscount='100%';
              filterd=100;
            }
            this.totals.pdiscount = filterd;
            this.totals.tdiscount = parseFloat(filterd*base/100);
          }

          if (inputd.indexOf('$')>-1) {
            filterd = parseFloat(this.inputdiscount.replace('$',''));

            if (filterd>base) {
              this.inputdiscount=this.round(base,2)+'$';
              filterd = base;
            }
            this.totals.tdiscount = filterd;
            this.totals.pdiscount = parseFloat(filterd*100/base);
          }

          if (isNaN(this.totals.pdiscount)) {this.totals.pdiscount = 0;this.totals.tdiscount = 0;}
          if (isNaN(this.totals.tdiscount)) {this.totals.pdiscount = 0;this.totals.tdiscount = 0;}
        }
      },
      calculate: function() {
        var app = this;

        //Seccion blanqueo de variables
        app.totals.net=0;
        app.totals.total=0;
        app.totals.ftaxes={};
        //Fin seccion blanqueo de variables

        //Seccion descuentos y calculo de net
        if (app.disciva) {
          app.totals.net = app.totals.gross - (app.totals.gross*app.totals.pdiscount/100);
        }
        if (!app.disciva) {
          app.totals.net = app.totals.prices - (app.totals.prices*app.totals.pdiscount/100);
        }
        app.totals.ftaxes= Object.assign({},app.totals.taxes);
        for (var key in app.totals.ftaxes) {
          app.totals.ftaxes[key] = app.totals.ftaxes[key] - (app.totals.ftaxes[key]*app.totals.pdiscount/100);
        }
        //Fin seccion descuentos y calculo de net

        //Seccion sumar iva y net en total
        if (app.disciva) {
          for (key in app.totals.ftaxes) {
            app.totals.total += app.totals.ftaxes[key];
          }
        }
        app.totals.total += app.totals.net;
        //Fin seccion sumar iva y net en total
        app.$emit('totalschanged',app.totals);
      },
      showInputDiscountRounded(){
        let inputd = this.inputdiscount;
        if(inputd !== undefined && inputd !== null){
          if (inputd.indexOf('$')>-1)
            return '$ ' + this.round(parseFloat(inputd.replace('$','')),2);
        }

        return inputd;
      }
    }

  }
</script>
